import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'
import { DBCheckBoxComment, DBCheckBox } from '_components'

class PatientCareCenterNoteObjectiveObsADLImpairmentsPeds extends React.Component {

    render() {
  
            return (
                <PatientCareCenterNoteSection id='obj_obs_ADL' name='ADL Impairments' level={2} noChildPadding={true}>
                     <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPADLBATH'
                         className={styles.checkbox}
                         label='Bathing'
                         textAreaStyle={styles.formTextArea}
                       />
                      </div>
                    </div>

                    <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPADLTOILET'
                         className={styles.checkbox}
                         label='Toileting'
                         textAreaStyle={styles.formTextArea}
                       />
                      </div>
                    </div>

                    <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPADLDRESS'
                         className={styles.checkbox}
                         label='Dressing'
                         textAreaStyle={styles.formTextArea}
                       />
                      </div>
                    </div>

                    <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPADLSWALLOW'
                         className={styles.checkbox}
                         label='Swallowing/eating'
                         textAreaStyle={styles.formTextArea}
                       />
                      </div>
                    </div>

                    <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPADLFEED'
                         className={styles.checkbox}
                         label='Feeding'
                         textAreaStyle={styles.formTextArea}
                       />
                      </div>
                    </div>

                    <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPADLFUNCMOB'
                         className={styles.checkbox}
                         label='Functional mobility'
                         textAreaStyle={styles.formTextArea}
                       />
                      </div>
                    </div>

                    <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPADLPERDEVCARE'
                         className={styles.checkbox}
                         label='Personal device care'
                         textAreaStyle={styles.formTextArea}
                       />
                      </div>
                    </div>

                    <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPADLPERHYG'
                         className={styles.checkbox}
                         label='Personal hygiene and grooming'
                         textAreaStyle={styles.formTextArea}
                       />
                      </div>
                    </div>
                    <div className={styles.form_row}>
                      <div className={styles.internal_heading_gap}>
                        <b>Fasteners</b>
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.checkbox_comment}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPFINONINTZIPPER'
                         className={styles.checkbox}
                         textAreaStyle={styles.formTextArea}
                         label='Non-interlocking zipper'
                       />
                       {this.props.isInterlockSelected && <>
                        <div className={styles.checkbox_position}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            label='Self'
                            entityKeyValue={this.props.opno}
                            field='OPFINONINTZIPPERSELF'
                        />
                        </div>              
                        <div className={styles.checkbox_position_2}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            label='Off-Self'
                            entityKeyValue={this.props.opno}
                            field='OPFINONINTZIPPEROFF'
                        />
                        </div>
                       </>
                       }
                 
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.checkbox_comment}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPFIBUTTONS'
                         className={styles.checkbox}
                         textAreaStyle={styles.formTextArea}
                         label='Buttons'
                       />
                        {this.props.isButtonSelected && <>
                        <div className={styles.checkbox_position}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            label='Self'
                            entityKeyValue={this.props.opno}
                            field='OPFIBUTTONSSELF'
                        />
                        </div>              
                        <div className={styles.checkbox_position_2}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            label='Off-Self'
                            entityKeyValue={this.props.opno}
                            field='OPFIBUTTONSOFF'
                        />
                        </div>
                       </>
                       }
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.checkbox_comment}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPFISNAPS'
                         className={styles.checkbox}
                         textAreaStyle={styles.formTextArea}
                         label='Snaps'
                       />
                        {this.props.isSnapSelected && <>
                        <div className={styles.checkbox_position}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            label='Self'
                            entityKeyValue={this.props.opno}
                            field='OPFISNAPSSELF'
                        />
                        </div>              
                        <div className={styles.checkbox_position_2}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            label='Off-Self'
                            entityKeyValue={this.props.opno}
                            field='OPFISNAPSOFF'
                        />
                        </div>
                       </>
                       }
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.checkbox_comment}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPFIINTZIPPER'
                         className={styles.checkbox}
                         textAreaStyle={styles.formTextArea}
                         label='Interlocking zipper'
                       />
                        {this.props.isIIZipperSelected && <>
                        <div className={styles.checkbox_position}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            label='Self'
                            entityKeyValue={this.props.opno}
                            field='OPFIINTZIPPERSELF'
                        />
                        </div>              
                        <div className={styles.checkbox_position_2}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            label='Off-Self'
                            entityKeyValue={this.props.opno}
                            field='OPFIINTZIPPEROFF'
                        />
                        </div>
                       </>
                       }
                    </div>
                  </div>

                  <div className={styles.form_row}>
                      <div className={styles.checkbox_comment}>
                        <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPFIBOWS'
                         className={styles.checkbox}
                         textAreaStyle={styles.formTextArea}
                         label='Tie bows'
                       />
                        {this.props.isTieBowSelected && <>
                        <div className={styles.checkbox_position}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            label='Self'
                            entityKeyValue={this.props.opno}
                            field='OPFIBOWSSELF'
                        />
                        </div>              
                        <div className={styles.checkbox_position_2}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            label='Off-Self'
                            entityKeyValue={this.props.opno}
                            field='OPFIBOWSOFF'
                        />
                        </div>
                       </>
                       }
                    </div>
                  </div>

                </PatientCareCenterNoteSection>
            );

    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));
    return {
        noteId: noteId,
        opno: opno,
        isInterlockSelected: (state.entities.notes.PTOBJECTIVEPEDS[opno]?.OPFINONINTZIPPER !== undefined && state.entities.notes.PTOBJECTIVEPEDS[opno]?.OPFINONINTZIPPER !== null),
        isButtonSelected: (state.entities.notes.PTOBJECTIVEPEDS[opno]?.OPFIBUTTONS !== undefined && state.entities.notes.PTOBJECTIVEPEDS[opno]?.OPFIBUTTONS !== null),
        isSnapSelected: (state.entities.notes.PTOBJECTIVEPEDS[opno]?.OPFISNAPS !== undefined && state.entities.notes.PTOBJECTIVEPEDS[opno]?.OPFISNAPS !== null),
        isIIZipperSelected: (state.entities.notes.PTOBJECTIVEPEDS[opno]?.OPFIINTZIPPER !== undefined && state.entities.notes.PTOBJECTIVEPEDS[opno]?.OPFIINTZIPPER !== null),
        isTieBowSelected: (state.entities.notes.PTOBJECTIVEPEDS[opno]?.OPFIBOWS !== undefined && state.entities.notes.PTOBJECTIVEPEDS[opno]?.OPFIBOWS !== null),
    };
}

const connectedPatientCareCenterNoteObjectiveObsADLImpairmentsPeds = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObsADLImpairmentsPeds);
export { connectedPatientCareCenterNoteObjectiveObsADLImpairmentsPeds as PatientCareCenterNoteObjectiveObsADLImpairmentsPeds };

